var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70711 0.613206C7.31658 0.222681 6.68342 0.222681 6.29289 0.613206L0.292893 6.61321C-0.0976311 7.00373 -0.0976311 7.6369 0.292893 8.02742C0.683417 8.41794 1.31658 8.41794 1.70711 8.02742L7 2.73453L12.2929 8.02742C12.6834 8.41794 13.3166 8.41794 13.7071 8.02742C14.0976 7.6369 14.0976 7.00373 13.7071 6.61321L7.70711 0.613206Z",
    fill: "#EB5B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.4448e8686139252ce700f0995cbc108b.svg";
export { ForwardRef as ReactComponent };